import axios from 'axios'
import ApiRota from './_api'
import * as msg from '../mensagens/mensagens'
import ServiceHandler from '@/modules/services/handler/service.handler'
import MensagensHelper, { MSG_SUCESSO, MSG_ERRO, MSG_ALERTA } from '@/utils/mensagens.helper'

export default {
  async login(dadosUsuario) {
    try {
      const retorno = await axios.post(`${ApiRota}/token`, dadosUsuario)
      return retorno
    } catch (error) {
      throw ServiceHandler.validar(error)
    }
  },
  async validaToken(token) {
    try {
      return await axios
        .get(`${ApiRota}/authenticate`, { headers: { Authorization: token } })
    } catch {
      throw MensagensHelper.gerar(MSG_ERRO, msg.TOKEN_INVALIDO)
    }
  },
  async enviaEmailRecuperacaoSenha(email) {
    try {
      await axios.post(`${ApiRota}/usuario/redefinicaosenha/${email}`)
      return MensagensHelper.gerar(MSG_SUCESSO, msg.EMAIL_ENVIADO)
    } catch (error) {
      throw ServiceHandler.validar(error)
    }
  },
  async retornaDadosUsuarioRecuperacaoSenha(hash) {
    try {
      const retorno = await axios.get(`${ApiRota}/usuario/dados/hash/${hash}`)
      if (retorno.data) {
        return retorno.data
      }

      throw MensagensHelper.gerar(MSG_ALERTA, msg.LINK_INVALIDO)
    } catch (error) {
      throw ServiceHandler.validar(error)
    }
  },
  async atualizarSenhaRecuperacaoSenha(usuario) {
    try {
      const retorno = await axios.put(`${ApiRota}/usuario/dados/update/password`, usuario)
      if (retorno.data.status === 'UPDATE') {
        return MensagensHelper.gerar(MSG_SUCESSO, msg.USUARIO_ALTERADO)
      }

      return MensagensHelper.gerar(MSG_ALERTA, msg.USUARIO_NAO_ALTERADO)
    } catch (error) {
      throw ServiceHandler.validar(error)
    }
  },
}
